define('controllers/avatar_uploader/Podio.Controllers.AvatarUploader',['require','underscore','lib/backbone/Backbone.PodioController','views/avatar_uploader/Podio.Views.AvatarUploader.Modal','lib/Podio.Routes','lib/Podio.Transport','lib/Podio.SingleSignOn','lib/view_helpers/base'],function(require) {

  var _ = require('underscore');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var ModalView = require('views/avatar_uploader/Podio.Views.AvatarUploader.Modal');
  var routes = require('lib/Podio.Routes');
  var transport = require('lib/Podio.Transport');
  var singleSignOn = require('lib/Podio.SingleSignOn');
  var viewHelpers = require('lib/view_helpers/base');

  return PodioController.extend({

    initialize: function(options) {
      _.bindAll(this, 'onOAuthComplete');

      this._super();

      this.modalView = new ModalView({
        eventBus: this.eventBus,
        ignoreReload: options ? options.ignoreReload : undefined
      });

      options = options || {};
      this.context = options.context;

      this._bindEvents();

      if (!options.ignoreRenderOnInit) {
        this.render();
      }
    },

    _bindEvents: function() {
      this.listenTo(this.eventBus, 'avatarUploaderView:avatarUploaded', this.onAvatarUploaded);
      this.listenTo(this.eventBus, 'avatarUploaderView:avatarRemoved', this.onAvatarRemoved);
      this.listenTo(this.eventBus, 'avatarUploaderView:connectLinkedAccount', this.onLinkedAccountConnect);
    },

    render: function() {
      if (this.context === 'invite') {
        this.modalView.renderInvite();
      } else {
        this.modalView.renderRegular();
      }
    },

    updateAvatarData: function(avatarId) {
      var url = routes.update_profile_path();
      var requestData = {
        contact: {
          avatar: avatarId
        }
      };

      transport.putJSON(url, { requestData: requestData });
    },

    onAvatarUploaded: function(avatarId) {
      this.updateAvatarData(avatarId);
    },

    onAvatarRemoved: function() {
      this.updateAvatarData('');
    },

    onLinkedAccountConnect: function(providerName) {
      singleSignOn.signals.onOAuthComplete.add(this.onOAuthComplete);
      singleSignOn.connect(providerName);
    },

    onOAuthComplete: function() {
      var self = this;
      var url = routes.get_profile_path();

      transport.getJSON(url, {}, function(responseData) {
        if (responseData.status === 'ok') {
          if (!_.isNull(responseData.data.object.avatar)) {
            self.modalView.renderUploadCompleted();
            self.modalView.showAvatar(viewHelpers.avatar_url_for(responseData.data.object, 'large'));
          } else {
            self.modalView.renderUploadPending();
          }
        }
      });
    }
  });

});

